export default __webpack_public_path__ + "static/media/forgot-password.63b63309.svg";